import React from 'react';
import PeoplePicker, { mapDbUserForPeoplePicker } from '../formFields/PeoplePicker';

const SettingsUsersPermissionItem = ({name, subname, extraText, users, onSelectedUsers}) => {

    return (
        <div className='settings-item'>
            <div className="settings-item-title">{name} {subname ? `(${subname})` : ''} {extraText ? ` - ${extraText}` : ''}</div>
            <PeoplePicker
                defaultUsers={users.map(u => mapDbUserForPeoplePicker(u))}
                onSelectedUsers={onSelectedUsers} 
                includeGroups={true}
            />
        </div>
    )

}

export default SettingsUsersPermissionItem;


// WEBPACK FOOTER //
// ./src/components/Settings/SettingsUsersPermissionItem.js